// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RE_X","content":"styles_content__27RS_"};